(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-header"]) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(cartProductRecommendations);

      const url = cartProductRecommendations.dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          cartProductRecommendations.innerHTML = recommendations.innerHTML;
        }

        MiniCart.init();
        cartProductRecommendations.querySelectorAll('.cart-item button[data-bs-toggle]').forEach(item => {
          item.addEventListener('click', event => {
            event.preventDefault();
          })
        });

      })
      .catch(e => {
        console.error(e);
      });

    };

    const cartProductRecommendations = document.querySelector('.cart-product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(cartProductRecommendations);

    Shopify.runPromotions();

    jQuery('section.cart .order-list [quantity-select]').each(function( index ) {

      if(jQuery(this).next().length == 0) jQuery(this).inputSpinner();

      jQuery(this).on("change", function (event) {
        var variant_id = jQuery(this).closest('[quantity-select]').data('variant-id');
        var item_price = jQuery(this).closest('[quantity-select]').data('variant-price');
        var item_original_price = jQuery(this).closest('[quantity-select]').data('variant-original-price');
        var qty = jQuery(this).val();
        var target_ele = jQuery(this);
        var parent_ele =jQuery(this).parent().parent().parent();

        Shopify.changeItem( variant_id, qty, function() {
          /* update line item price */
          parent_ele.find('[item-price]').html( Shopify.formatMoney( (item_price*qty) ));
          if( item_original_price > item_price)
            parent_ele.find('[item-original-price]').html( Shopify.formatMoney( (item_original_price*qty) ));
        });
      });
    });

    /* Click Add-to-Cart on item */
    jQuery('[remove-from-cart]').on('click', function (evt) {
      // if variant ID passed, use that
      evt.preventDefault();
      Shopify.removeItem( jQuery(this).data('variant-id') );
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  var product_grid_carousel = jQuery('.product-grid.carousel .row');
  var product_grid_display = product_grid_carousel.data('slider-display');
  if(product_grid_carousel.length > 0 ) {
    if(product_grid_display == 'all' || ( product_grid_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      product_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: product_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: product_grid_carousel.data('slider-arrows'),
        dots: product_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '0px',
              infinite: true
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  var product = JSON.parse(document.getElementById('ProductJson').innerHTML);
  var no_variant_mip = product.tags.includes('clearance');
  var option_count = product.options.length;
  var current_variant = getCurrentVariant($('[variant-select]').val());

  function setVariant(variant) {
    current_variant = variant;

    jQuery('[variant-title]').html(current_variant.title);
    jQuery('[variant-select] option').attr('selected', false);
    jQuery('[variant-select] option[value="' + current_variant.id + '"]').attr('selected', true);

    // update UI items
    updatePrice(); // Updates display price and sale display
    updateImages();
    changeSpecs(current_variant.id);
    updateCTA(current_variant.available); // Display Buy CTA for Variant
    updateHistoryState(); // Adds Variant ID to URL for deeplinking
  }

  function updatePrice() {
    var productPrice = current_variant.price;
    var originalPrice = current_variant.compare_at_price;

    // update price
    document.querySelector('.product-header [data-product-price]').innerHTML = Shopify.formatMoney(productPrice);

    // if on sale...
    if (productPrice < originalPrice) {
      jQuery('.product-header [data-product-price]').addClass('saleprice');
      jQuery('.product-header [data-original-price]').text(Shopify.formatMoney(originalPrice));
      jQuery('.product-header [data-original-price], .badge-sale.badge-variant-sale').removeClass('d-none');
    } else {
      jQuery('.product-header [data-product-price]').removeClass('saleprice');
      jQuery('.product-header [data-original-price]').text('');
      jQuery('.product-header [data-original-price], .badge-sale.badge-variant-sale').addClass('d-none');
    }
  }

  function updateCTA(is_available) {
    if (is_available == true) {
      jQuery('.klaviyo-bis-trigger').hide();
      jQuery('#AddToCartButton').removeAttr('disabled');
      jQuery('#AddToCartButton span').html(lang_add_to_cart);
    } else {
      jQuery('.klaviyo-bis-trigger').show();
      jQuery('#AddToCartButton').attr('disabled', true);
      jQuery('#AddToCartButton span').html(lang_sold_out);
    }
  }

  function updateImages() {
    var variant_id = current_variant.id;
    var variant_image = current_variant.featured_image;
    var variant_carousel = jQuery('#variant-carousel-' + variant_id);
    var media_carousel = jQuery('#mip-carousel div.carousel-hero');

    // If product has variants load MIP Variants
    if (variant_carousel.length > 0) {
      jQuery('#mip-carousel div').replaceWith('<div>' + variant_carousel.html() + '</div>'); // Replace default image loaded with variant container
      if (variant_carousel.hasClass('variant-carousel-container')) {
        initMip();
      }
    } else if (media_carousel.length < 1) {
      var sizedSrcset = Shopify.resizeImage(variant_image.src, '500x'); //resize
      var sizedSrc = Shopify.resizeImage(variant_image.src, '800x'); //resize
      jQuery('#mip-carousel div').replaceWith(
        '<div><picture><source media="(max-width: 500px)" srcset="' +
          sizedSrcset +
          '"><img src="' +
          sizedSrc +
          '" width="800" height="800" class="img-fluid" alt="' +
          product.title +
          '"></picture></div>'
      );
    } else {
      jQuery('#mip-carousel div.carousel-hero').slick('slickGoTo', variant_image.position - 1);
    }
  }

  function initMip() {
    var carousel_element = jQuery('#mip-carousel div.carousel-hero').not('.slick-initialized');
    // If carousel content exists
    if (carousel_element.length > 0) {
      carousel_element.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        touchMove: true,
        arrows: true,
      });
    } // end If carousel content exists
  }

  function updateHistoryState() {
    // Update history state for product deeplinking
    var newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?variant=' +
      current_variant.id;
    window.history.replaceState({ path: newurl }, '', newurl);
  }

  function getCurrentVariant(variantId) {
    var variants = product.variants;
    // map variants and return the selected one

    var found = jQuery.map(variants, function (variant) {
      if (variant.id == variantId) {
        return variant; // return matching variant object
      }
    });

    return found[0]; // returns single array so pull out first element object
  }

  /* JS loaded: hide dropdown and show option swap */
  document.querySelector('.variant-select').style.display = 'none';
  var options_ele = document.querySelectorAll('.product-options');
  [].forEach.call(options_ele, function (ele) {
    ele.style.display = 'block';
  });

  jQuery('.option-group :radio').on('change', function () {
    /* loop through all available options and get currently selected value */
    var selected_options = [];
    product.options.forEach(async function (option) {
      selected_options.push(document.querySelector('[data-option="' + option + '"] input:checked').value);
    });

    /* find variant by selected value(s) */
    var selected_variant = product.variants.find(function (variant, index) {
      if (
        selected_options.length == 2 &&
        variant.option1 == selected_options[0] &&
        variant.option2 == selected_options[1]
      ) {
        return true;
      } else if (selected_options.length == 1 && variant.option1 == selected_options[0]) {
        return true;
      } else {
        return false;
      }
    });

    /* If variant does't exist, show as sold out w/o notify ability */
    if (!selected_variant) {
      //alert("That combination isn't available. Choose another option.");
      updateCTA(false);
      jQuery('.klaviyo-bis-trigger').hide();
      return false;
    }

    setVariant(selected_variant);
  });


  /* ON PAGE LOAD */
  if (jQuery('#mip-carousel div.carousel-hero').length > 1) {
    jQuery('#mip-carousel div.carousel-hero').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: 'ondemand',
      touchMove: true,
      arrows: true,
    });
  }

  initMip();
  setVariant(current_variant);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    

  document.addEventListener('rebuy:cart.change', (event) => { 
    // console.log('rebuy:cart.change event', event.detail); 
    setTimeout(() => {
      $("#deal").load(location.href + " #cart-bundle-deal");
    }, 66);
  });

  var product = JSON.parse(document.getElementById('ProductJson').innerHTML);
  var no_variant_mip = product.tags.includes('clearance');
  var option_count = product.options.length;
  var current_variant = getCurrentVariant($('[variant-select]').val());

  function setVariant(variant, optionType) {
    current_variant = variant;
    // debugger;
    jQuery('[variant-select] option').attr('selected', false);
    jQuery('[variant-select] option[value="' + current_variant.id + '"]').attr('selected', true);

    // update UI items
    updateColorName(current_variant.options);
    updateQuantity(current_variant);
    updatePrice(); // Updates display price and sale display
    updateImages();
    changeSpecs(current_variant.id);
    updateCTA(current_variant.available); // Display Buy CTA for Variant
    updateHistoryState(); // Adds Variant ID to URL for deeplinking
  }

  function updateColorName(current_variant_options) {
    let color_name = '';

    // find which option is a color option
    product.options.forEach(function(option, index) {
      if (['color', 'colour'].includes(option.toLowerCase())) {
        color_name = current_variant_options[index];
      }
    });

    jQuery('.current-variant-color-name')?.html(color_name);
  }

  function updateQuantity(variant) {
    var quantity_input = jQuery('#product_buybox input#quantity');
    var quantity_minus_button = jQuery('#product_buybox button.quantity-button-minus');
    var quantity_plus_button = jQuery('#product_buybox button.quantity-button-plus');

    if (!quantity_input) return false;
    quantity_input.val(1);
    quantity_minus_button.attr('disabled', 'disabled');

    if (variant.available == false) {
      quantity_input.attr('disabled', 'disabled');
      quantity_input.attr('max', 1); 
      quantity_plus_button.attr('disabled', 'disabled');
    } else {
      quantity_input.removeAttr('disabled'); 
      quantity_plus_button.removeAttr('disabled'); 
      quantity_input.attr('max', 25); // set max possible quantity
    }
  }

  function updatePrice() {
    var productPrice = current_variant.price;
    var originalPrice = current_variant.compare_at_price;

    // update price
    document.querySelector('.product-header [data-product-price]').innerHTML = Shopify.formatMoney(productPrice);

    // if on sale...
    if (productPrice < originalPrice) {
      jQuery('.product-header [data-product-price]').addClass('saleprice');
      jQuery('.product-header [data-original-price]').text(Shopify.formatMoney(originalPrice));
      jQuery('.product-header [data-original-price], .badge-sale.badge-variant-sale').removeClass('d-none');
    } else {
      jQuery('.product-header [data-product-price]').removeClass('saleprice');
      jQuery('.product-header [data-original-price]').text('');
      jQuery('.product-header [data-original-price], .badge-sale.badge-variant-sale').addClass('d-none');
    }
  }

  function updateCTA(is_available) {
    if (is_available == true) {
      jQuery('.klaviyo-bis-trigger').hide();
      jQuery('#AddToCartButton').removeAttr('disabled');
      jQuery('#AddToCartButton span').html(lang_add_to_cart);
    } else {
      jQuery('.klaviyo-bis-trigger').show();
      jQuery('#AddToCartButton').attr('disabled', true);
      jQuery('#AddToCartButton span').html(lang_sold_out);
    }
  }

  function getVariantImages(variantId) {
    return media_gallery.variants[variantId]?.images || [];
  }

  function updateImages() {
    var variant_id = current_variant.id;
    var variant_image = current_variant.featured_image;
    var variant_carousel_elem = jQuery('#variant-carousel-' + variant_id);
    var media_carousel_elem = jQuery('#mip-carousel div.carousel-hero');

    // update desktop media grid
    let media_grid_html = '';
    let variant_images = getVariantImages(variant_id);
    variant_images.forEach(function(item, index) {     
      media_grid_html += `<li class="media-grid-item is-variant-specific">`;
      media_grid_html += `  <a class="media-grid-item-wrapper media-grid-item-wrapper-image" href="${item.src_lg}" data-pswp-width="1400" data-pswp-height="1400" target="_blank">`;
      media_grid_html += `    <img class="img-fluid" src="${( variant_images.length <= 2 ? item.src_md : item.src_sm )}" width="788" height="788" alt="${product.title}" loading="${index <= 4 ? 'eager' : 'lazy'}" />`;
      media_grid_html += `  </a>`;
      media_grid_html += `</li>`;
    });
    if (media_grid_html != '') {
      jQuery('.media-grid > .media-grid-item.is-variant-specific').remove();
      jQuery('.media-grid').prepend(media_grid_html);
      
      // Reinitialize PhotoSwipe after updating images
      if (typeof window.reinitPhotoSwipe === 'function') {
        window.reinitPhotoSwipe();
      }
    }

    // If product has variants load MIP Variants (update mobile carousel)
    if (variant_carousel_elem.length > 0) {
      jQuery('#mip-carousel div').replaceWith('<div>' + variant_carousel_elem.html() + '</div>'); // Replace default image loaded with variant container
      if (variant_carousel_elem.hasClass('variant-carousel-container')) {
        initMip();
      }
    } else if (media_carousel_elem.length < 1) {
      var sizedSrc = Shopify.resizeImage(variant_image.src, '800x'); //resize
      jQuery('#mip-carousel div').replaceWith(`<div><img src="${sizedSrc}" width="800" height="800" class="img-fluid" alt="${product.title}"></div>`);
    } else {
      jQuery('#mip-carousel div.carousel-hero').slick('slickGoTo', variant_image.position - 1);
    }
  }

  function initMip() {
    var carousel_element = jQuery('#mip-carousel div.carousel-hero:not(.slick-initialized)');
    if (carousel_element.length === 1) {
      carousel_element.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        lazyLoad: 'ondemand',
        touchMove: true,
        autoplay: false,
        arrows: false,
        dots: true,
        draggable: true,
        touchMove: true,
        infinite: false,
        useCSS: true,
        useTransform: true
      });
    }
  }

  function updateHistoryState() {
    // Update history state for product deeplinking
    var newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?variant=' +
      current_variant.id;
    window.history.replaceState({ path: newurl }, '', newurl);
  }

  // add minus/plus button functionality for our quantity input
  function assignQuantityInputControl() {
    var quantity_input = jQuery('#product_buybox input#quantity');
    var quantity_minus_button = jQuery('#product_buybox button.quantity-button-minus');
    var quantity_plus_button = jQuery('#product_buybox button.quantity-button-plus');
    if (!quantity_input || !quantity_minus_button || !quantity_plus_button) return false;

    function udpateButtonStates() {
      let current_value = parseInt(quantity_input.val());
      let max_value = parseInt(quantity_input.attr('max'));

      if (current_value <= 1) {
        quantity_minus_button.attr('disabled', 'disabled');
      } else {
        quantity_minus_button.removeAttr('disabled');
      }

      if (current_value >= max_value) {
        quantity_plus_button.attr('disabled', 'disabled');
      } else {
        quantity_plus_button.removeAttr('disabled');
      }
    }

    quantity_minus_button.click(function(e) {
      e.preventDefault();
      let current_value = parseInt(quantity_input.val());
      
      if (isNaN(current_value) || current_value <= 1) {
        quantity_input.val(1);
      } else {
        quantity_input.val(current_value - 1);
      }

      udpateButtonStates();
      return;
    })

    quantity_plus_button.click(function(e) {
      e.preventDefault();
      let current_value = parseInt(quantity_input.val());
      let max_value = parseInt(quantity_input.attr('max'));

      if (isNaN(current_value)) {
        quantity_input.val(1);
      } else if (current_value >= max_value) {
        quantity_input.val(max_value);
      } else {
        quantity_input.val(current_value + 1);
      }

      udpateButtonStates();
      return;
    })

    quantity_input.on('input change', function(e) {
      udpateButtonStates();
    });
  }

  function refreshVariantButtonStates(args) {
    // if color was selected, find all sizes for that color
    // loop through size option buttons and disable if size variant not available
    // if size was selected, find all colours for that size
    // loop through colour option buttons and disable if colour variant not available
    //
    // TODO: this can be made generic for any combination of options
    // look at product.options which has the ordering of Color and Size options.
    // that ordering can be used for the selected_options array index
    const optionType = args?.optionType;
    const selected_options = args?.selected_options;
    if (optionType === 'Color') {
      const matchingSizes = product.variants.filter(function (variant, index) {
        return variant.option1 === selected_options[0];
      });
      const sizeButtons = document.querySelectorAll('[data-option="Size"] input');
      for (const sizeButton of sizeButtons) {
        const matchingSizeButton = matchingSizes.find(function (variant, index) {
          return variant.option2 === sizeButton.value;
        });
        if (!matchingSizeButton) {
          sizeButton.disabled = true;
          sizeButton.parentElement.classList.add('size-disabled');
        } else {
          sizeButton.disabled = false;
          sizeButton.parentElement.classList.remove('size-disabled');
        }
      }
    }

    if (optionType === 'Size') {
      const matchingColours = product.variants.filter(function (variant, index) {
        return variant.option2 === selected_options[1];
      });
      const colourButtons = document.querySelectorAll('[data-option="Color"] input');
      for (const colourButton of colourButtons) {
        const parentElement = colourButton.parentElement;
        const matchingColourButton = matchingColours.find(function (variant, index) {
          return variant.option1 === colourButton.value;
        });
        if (!matchingColourButton) {
          colourButton.disabled = true;
          parentElement.classList.add('colour-disabled');
        } else {
          colourButton.disabled = false;
          parentElement.classList.remove('colour-disabled');
        }
      }
    }
  }

  function getCurrentVariant(variantId) {
    var variants = product.variants;
    // map variants and return the selected one

    var found = jQuery.map(variants, function (variant) {
      if (variant.id == variantId) {
        return variant; // return matching variant object
      }
    });

    // returns single array so pull out first element object
    const variant = found[0];

    refreshVariantButtonStates({ selected_options: variant.options, optionType: 'Color' });
    // refreshVariantButtonStates({ selected_options: variant.options, optionType: 'Size' });

    // this is made visible only after the button states have been updated
    jQuery('#product_buybox').css('visibility', 'visible');
    return variant;
  }

  /* JS loaded: hide dropdown and show option swap */
  document.querySelector('.variant-select').style.display = 'none';
  var options_ele = document.querySelectorAll('.product-options');
  [].forEach.call(options_ele, function (ele) {
    ele.style.display = 'block';
  });

  jQuery('.option-group :radio').on('change', function (event) {
    /* loop through all available options and get currently selected value */
    var selected_options = [];
    product.options.forEach(async function (option) {
      selected_options.push(document.querySelector('[data-option="' + option + '"] input:checked').value);
    });

    refreshVariantButtonStates({ optionType: event.target.name, selected_options });

    /* find variant by selected value(s) */
    var selected_variant = product.variants.find(function (variant, index) {
      if (
        selected_options.length == 2 &&
        variant.option1 == selected_options[0] &&
        variant.option2 == selected_options[1]
      ) {
        return true;
      } else if (selected_options.length == 1 && variant.option1 == selected_options[0]) {
        return true;
      } else {
        return false;
      }
    });

    /* If variant doesn't exist, show as sold out w/o notify ability */
    if (!selected_variant) {
      updateCTA(false);
      jQuery('.klaviyo-bis-trigger').hide();
      return false;
    }

    setVariant(selected_variant);
  });

  /* ON PAGE LOAD */
  initMip();
  assignQuantityInputControl();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendations);

      const url = productRecommendations.dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }
		MiniCart.bindUIActions();
      })
      .catch(e => {
        console.error(e);
      });

    };

    const productRecommendations = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendations);


  } catch(e) { console.error(e); }
})();
})();
